import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Entry } from 'contentful';
import { IagPortalFaqsPage } from 'src/app/model/page/group/iag-portal/iag-portal-faqs-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-iag-portal-faqs-page',
  templateUrl: './iag-portal-faqs-page.component.html',
  styleUrls: ['./iag-portal-faqs-page.component.scss']
})
export class IagPortalFaqsPageComponent implements OnInit {
  param: number = -1;
  iagPortalFaqsPage: IagPortalFaqsPage = {} as IagPortalFaqsPage;
  BackLinkTitle: string = '';
  BackLinkURL: string = '';
  BackLinkIcon: string = '';

  constructor(private router: Router, private contentfulService: ContentfulService, private sharedDataService: SharedDataService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'iag-portal-faq') {
        this.iagPortalFaqsPage.htmlTitle = title.htmlTitle;
      }
    });
    this.param = Number(this.router.url.split('#').pop());

    this.iagPortalFaqsPage.sections = [];
    const query = { 'fields.title': 'IAG Booking Portal FAQs' };
    this.contentfulService.getPageContentResponse(query).then((iagPortalFaqsPageEntries) => {
      this.mapBanner(iagPortalFaqsPageEntries.includes.Entry);
      this.sharedDataService.addSharedData(this.iagPortalFaqsPage.banner);
      this.mapPageInfo(iagPortalFaqsPageEntries.items);
      this.mapSections(iagPortalFaqsPageEntries.includes.Entry);
    });
    this.contentfulService.getPageContentWithItems(query).then((linkItems) => {
      this.BackLinkTitle = linkItems[0]?.fields.constants[0].BackLinkTitle;
      this.BackLinkURL = linkItems[0]?.fields.constants[0].BackLinkURL;
      this.BackLinkIcon = linkItems[0]?.fields.constants[0].BackLinkIcon;
    });
  }

  private mapBanner(iagPortalFaqsPageEntries: Entry<any>[]) {
    iagPortalFaqsPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let image: any = entry.fields['image'] as string;
    let video: any = entry.fields['video'] as string;
    this.iagPortalFaqsPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: image.fields.file.url,
      video: video?.fields?.file?.url
    };
  }

  private mapPageInfo(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      let editorDetails = entry.fields?.editorDetails?.split('#');
      this.iagPortalFaqsPage.banner.lastUpdated = entry.fields?.lastUpdated;
      this.iagPortalFaqsPage.banner.url = entry.fields?.url;
      this.iagPortalFaqsPage.banner.editorEmail = editorDetails?.pop();
      this.iagPortalFaqsPage.banner.editorShortName = editorDetails?.pop();
      this.iagPortalFaqsPage.banner.editorFullName = editorDetails?.pop();
      this.iagPortalFaqsPage.htmlTitle = entry.fields.htmlTitle;
    });
  }
  private mapSections(iagPortalFaqsPageEntries: Entry<any>[]) {
    iagPortalFaqsPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapEntryToSection(entry);
      });

    this.iagPortalFaqsPage.sections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToSection(entry: Entry<any>) {
    let title: any = entry.fields['title'] as string;
    this.iagPortalFaqsPage.sections.push({
      title: title.split('#').pop(),
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number
    });
  }
}
